import Cookies from "js-cookie";
import { handleLogin } from "@store/authentication";
import {
  receiveServerErrors,
  receiveValidationErrors,
  RESET_LOADING,
  SERVER_DOWN_ERROR,
} from "../Shared/Errors/errorActions";
import axios from "axios";

export const RECEIVE_CURRENT_SESSION = "RECEIVE_CURRENT_SESSION";
export const REQUEST_CURRENT_SESSION = "REQUEST_CURRENT_SESSION";
export const RECEIVE_CURRENT_SESSION_INFLUENCER =
  "RECEIVE_CURRENT_SESSION_INFLUENCER";
export const LOGOUT = "LOGOUT";

export const requestCurrentSession = () => ({ type: REQUEST_CURRENT_SESSION });

export const receiveCurrentSession = (session) => ({
  type: RECEIVE_CURRENT_SESSION,
  session,
});

export const receiveCurrentSessionInfluencer = (influencer) => ({
  type: RECEIVE_CURRENT_SESSION_INFLUENCER,
  influencer,
});

export const login = (data, callback, fieldError) => (dispatch) => {
  dispatch(requestCurrentSession());
  axios
    .post(`${process.env.REACT_APP_BASE_URL}/jwt_api/login`, data, {})
    .then((res) => {
      const { data } = res;
      if (!data.roles.includes("vip_influencer")) {
        //TODO: can see the jwt in the react-redux store debugger
        dispatch(receiveCurrentSession(data));
        if (data.currentUser.registration_completed) {
          dispatch(handleLogin(data.currentUser));
          Cookies.set("uId", data.currentUser._id);
          Cookies.set("jwt", data.jwt);
          localStorage.setItem("session", JSON.stringify(data));
        }
      }
      callback(data);
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        // Request was canceled
        console.error("Request canceled:", err.message);
      } else if (err.response) {
        // The request was made and the server responded with a status code
        if (
          err.response.data.code === 208 &&
          err.response.data.error_message ===
            "The email address you entered is not connected to an account."
        ) {
          fieldError(err.response.data.error_message);
          err.response.responseJSON = [err.response.data.error_message];
          dispatch(
            receiveValidationErrors({
              email: "This email is not connected to an account",
            })
          );
        } else if (
          err.response.data.code === 208 &&
          err.response.data.error_message === "Invalid password."
        ) {
          err.response.responseJSON = [err.response.data.error_message];
          dispatch(
            receiveValidationErrors({
              password: err.response.data.error_message,
            })
          );
          dispatch({ type: RESET_LOADING });
        } else if (err.response.data[0] === "Invalid Credentials") {
          err.response.responseJSON = err.response.data;
          dispatch(
            receiveValidationErrors({
              email: "Invalid Credentials",
              password: "Invalid Credentials",
            })
          );
        }
      } else if (err.request) {
        // dispatch(receiveServerErrors({ statusText: err.message }));
        // dispatch(
        //   receiveValidationErrors({
        //     password: err.message || "Something went wrong",
        //   })
        // );
        dispatch({ type: SERVER_DOWN_ERROR, serverDownModal: true });
        dispatch({ type: RESET_LOADING });
      } else {
        // Something happened in setting up the request that triggered an error
        console.error("Request setup error:", err.message);
      }
    });
};

const deleteSession = () => {
  const { store } = window;
  $.ajax({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/api/session`,
    success() {
      store.dispatch({ type: LOGOUT });
    },
    error(xhr) {
      store.dispatch(receiveServerErrors(xhr));
    },
  });
};

export const logout = () => (dispatch) => {
  const { store } = window;
  const globalState = store.getState();
  const { session } = globalState || {};
  if (session && !session.hasOneVisit) {
    $.ajax({
      method: "put",
      url: `${process.env.REACT_APP_BASE_URL}/api/users/current`,
      data: {},
      success() {
        deleteSession();
      },
      error(xhr) {
        dispatch(receiveServerErrors(xhr));
      },
    });
  } else {
    deleteSession();
  }
};

export const updateSession = (data, callback, fieldError) => (dispatch) => {
  dispatch(requestCurrentSession());
  axios
    .put(`${process.env.REACT_APP_BASE_URL}/jwt_api/session`, data, {})
    .then((res) => {
      const { data } = res;
      dispatch(receiveCurrentSession(data));
      callback(data);
    })
    .catch((err) => {
      if (err.response.data[0] === "Invalid Credentials") {
        //Pushing Error for state
        err.response.responseJSON = err.response.data;
        dispatch(receiveServerErrors(err.response));
      } else if (
        err.response.data[0] === "The link is invalid or has expired"
      ) {
        //Pushing Error for state
        err.response.responseJSON = err.response.data;
        dispatch(receiveServerErrors(err.response));
      }
      dispatch(receiveServerErrors(err.response));
    });
};

export const fetchCurrentInfluencer = () => (dispatch) => {
  dispatch(requestCurrentSession());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/api/influencers/get_current_influencer`,
    success({ influencer }) {
      dispatch(receiveCurrentSessionInfluencer(influencer));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const facebookLogin = () => {
  window.location.href = "/facebook_integration";
};

export const googleLogin = (data, callback, fieldError) => (dispatch) => {
  dispatch(requestCurrentSession());
  axios
    .post(
      `${process.env.REACT_APP_BASE_URL}/jwt_api/login/sign_up_with_google`,
      data,
      {}
    )
    .then((res) => {
      const { data } = res;
      if (!data.roles.includes("vip_influencer")) {
        dispatch(receiveCurrentSession(data));
        dispatch(handleLogin(data.currentUser));
        Cookies.set("uId", data.currentUser._id);
        Cookies.set("jwt", data.jwt);
        localStorage.setItem("session", JSON.stringify(data));
      }
      callback(data);
    })
    .catch((err) => {
      if (err.response.data.code === 208) {
        fieldError(err.response.data.error_message);
        err.response.responseJSON = [err.response.data.error_message];
        dispatch(receiveServerErrors(err.response));
      }
    });
};

export const uploadUserBrand = (data, callback, fieldError) => (dispatch) => {
  dispatch(requestCurrentSession());
  axios
    .post(
      `${process.env.REACT_APP_BASE_URL}/jwt_api/users/update_brand_details`,
      data,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    )
    .then((res) => {
      const { data } = res;
      dispatch(receiveCurrentSession(data));
      callback(data);
    })
    .catch((err) => {});
};

export const resend_confirmation_email =
  (data, callback, fieldError) => (dispatch) => {
    dispatch(requestCurrentSession());
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/jwt_api/users/resend_confirmation_email`,
        { params: { email: data } },
        {}
      )
      .then((res) => {
        const { data } = res;
        // dispatch(receiveCurrentSession(data));
        callback(data);
      })
      .catch((err) => {
        if (err.response.data.code === 208) {
          fieldError(err.response.data.error_message);
          err.response.responseJSON = [err.response.data.error_message];
          dispatch(receiveServerErrors(err.response));
        }
      });
  };

export const send_reset_email = (data, callback, fieldError) => (dispatch) => {
  dispatch(requestCurrentSession());
  axios
    .post(
      `${process.env.REACT_APP_BASE_URL}/jwt_api/recovery_passwords`,
      data,
      {}
    )
    .then((res) => {
      const { data } = res;
      dispatch(receiveCurrentSession(data));
      callback(data);
    })
    .catch((err) => {
      fieldError(err.response.data[0]);
      err.response.responseJSON = err.response.data;
      dispatch(receiveServerErrors(err.response));
    });
};

export const reset_password = (data, callback, fieldError) => (dispatch) => {
  dispatch(requestCurrentSession());
  axios
    .put(
      `${process.env.REACT_APP_BASE_URL}/jwt_api/recovery_passwords`,
      data,
      {}
    )
    .then((res) => {
      const { data } = res;
      dispatch(receiveCurrentSession(data));
      callback(data);
    })
    .catch((err) => {
      if (err.response.data.code === 208) {
        fieldError(err.response.data.error_message);
        err.response.responseJSON = [err.response.data.error_message];
        dispatch(receiveServerErrors(err.response));
      }
    });
};
